import get from "../../../api/methods/get";
import { NEWS_QUERY } from "./newsEndpoints";

export const queryNews = async () => {

    let result = await get(NEWS_QUERY);
    let json = await result.json();
    return json.data;

}
